import React from "react";

import EmojiHappy from "images/emoji_happy.png";
import EmojiSad from "images/emoji_sad.png";

const AssessmentValueRow = ({ qus, value, setValue }) => {
    return (
        <div
            className="col-md-12 col-sm-12 col-xs-12 padding-remove"
            style={{
                margin: "5px", // Vertical spacing between rows
                padding: "10px", // Inner spacing
                backgroundColor: "#f9f9f9", // Light background
                borderRadius: "8px", // Rounded corners
            }}
        >
            <div
                className="col-md-12 col-sm-12 col-xs-12 pull-right padding-remove"
                style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    height: "100%",
                }}
            >
                <div className="col-md-8 col-sm-8 col-xs-8 padding-remove">
                    <label
                        className="control-label text-left col-md-12 col-sm-12 col-xs-12"
                        htmlFor="name"
                    >
                        {qus}
                    </label>
                </div>
                <div className="col-md-4 col-sm-4 col-xs-4 padding-remove">
                    <div
                        className="col-md-6 col-sm-6 col-xs-6 padding-remove"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                        }}
                        onClick={() => setValue(10)}
                    >
                        <img
                            src={EmojiHappy}
                            alt="Happy"
                            height="100%"
                            width="100%"
                            style={{
                                width: "35px",
                                border: value === 10 ? "2px solid blue" : "1px solid #ddd",
                                display: "block",
                                cursor: "pointer",
                                borderRadius: "50%",
                                padding: "1px",
                                backgroundColor: value === 10 ? "#e6f7ff" : "transparent",
                            }}
                        />
                    </div>
                    <div
                        className="col-md-6 col-sm-6 col-xs-6 padding-remove"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                        }}
                        onClick={() => setValue(20)}
                    >
                        <img
                            src={EmojiSad}
                            alt="Sad"
                            height="100%"
                            width="100%"
                            style={{
                                width: "35px",
                                border: value === 20 ? "2px solid blue" : "1px solid #ddd",
                                display: "block",
                                cursor: "pointer",
                                borderRadius: "50%",
                                padding: "1px",
                                backgroundColor: value === 20 ? "#e6f7ff" : "transparent",
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssessmentValueRow;
